query ContentStatus($id: ID!) {
  content(id: $id) {
    id
    processingStatus
    transcodingError
    duration
    video {
      id
      uid
      fileName
      readyToStream
      duration
      transcodingError
    }
    pendingVideo {
      id
      uid
      fileName
    }
    playback {
      token
      hlsUrl
      iframeUrl
    }
  }
}
